import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col, Card } from "react-bootstrap";
import config from "../../config/config";
import axios from "axios";
import Loader from "../loader/Loader";
import { toast } from "react-toastify";
import { getAuthToken } from "../../utils/token";
import {formatDate} from "../../utils/formatDate"

export default function ReviewMaterialOnHold({show,handleClose,inholdmaterialId,}) {
  const [inholdmaterials, setInholdmaterials] = useState(null);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    correctiveMeasure: "",
    measureEffectiveness: "",
    qtyAccepted: "",
    qtyRejected: "",
  });

   const resetForm = () => {
    setFormData({
      correctiveMeasure: "",
      measureEffectiveness: "",
      qtyAccepted: "",
      qtyRejected: "",
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const fetchInholdmaterials = async () => {
    const token = getAuthToken();
    if (!token || !inholdmaterialId) return;

    try {
      setLoading(true);
      const response = await axios.get(
        `${config.API}/supervisor/showinholdmaterial/${inholdmaterialId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.success) {
        setInholdmaterials(response.data.in_hold_material);
      } else {
        setInholdmaterials(null);
      }
    } catch (err) {
      toast.error("Failed to fetch material details");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    const token = getAuthToken();
    if (!token || !inholdmaterials) return;

    const payload = {
      material_name: inholdmaterials.material_master?.material_name,
      review_date: inholdmaterials.inspection_date,
      hold_qty: inholdmaterials.expected_qty,
      nc_nature: inholdmaterials.decision,
      corrective_measure: formData.correctiveMeasure,
      measure_effectiveness: formData.measureEffectiveness,
      quantity_accepted: formData.qtyAccepted,
      quantity_rejected: formData.qtyRejected,
    };

    try {
      setLoading(true);
      const response = await axios.post(
        `${config.API}/supervisor/inholdmaterial/${inholdmaterialId}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.message) {
        toast.success(response.data.message);
        resetForm()
        handleClose();
      }
    } catch (err) {
      toast.error("Failed to submit review");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show) fetchInholdmaterials();
  }, [show, inholdmaterialId]);

  return (
    <Modal show={show} onHide={handleClose} size="md" centered className="font_family">
      <Modal.Body className="p-4">
        <h5 className="fw-bold mb-3">Review Product on Hold</h5>

        {loading && <Loader />}

        {inholdmaterials && (
          <Card className="bg-light border-0 shadow-sm p-3 mb-4">
            <Row>
              <Col md={6}>
                <p><strong>Name:</strong> {inholdmaterials.material_master?.material_name}</p>
                <p><strong>Qty:</strong> {inholdmaterials.expected_qty}</p>
              </Col>
              <Col md={6}>
                <p><strong>Date:</strong> {formatDate(inholdmaterials.inspection_date)}</p>
                <p><strong>Nature:</strong> {inholdmaterials.decision}</p>
              </Col>
            </Row>
          </Card>
        )}

        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Corrective Measure</Form.Label>
            <Form.Select
              name="correctiveMeasure"
              value={formData.correctiveMeasure}
              onChange={handleChange}
            >
              <option value="">Select Measure</option>
              <option value="Rework">Rework</option>
              <option value="Repair">Repair</option>
              <option value="Scrap">Scrap</option>
              <option value="Return to Vendor">Return to Vendor</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Measure Effectiveness</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="measureEffectiveness"
              value={formData.measureEffectiveness}
              onChange={handleChange}
            />
          </Form.Group>

          <Row>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Quantity Accepted</Form.Label>
                <Form.Control
                  type="number"
                  name="qtyAccepted"
                  value={formData.qtyAccepted}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label>Quantity Rejected</Form.Label>
                <Form.Control
                  type="number"
                  name="qtyRejected"
                  value={formData.qtyRejected}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="dark" onClick={handleSubmit} disabled={loading}>
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
